export const EN = { code: 'en', language: '' }


export const allLanguages = [
  EN
  
]
